export default {
    state: () => ({
        avatar: "",
        fio: "",
        date: "",
        pol: "",
        password: "",
        city: "",
        nomberPhone: "",
        email: "",
        BYZ: "",
        way: "",
        prof: "",
        cours: "",
        skills: [],
        activity: "",
        vacancy: "",
        achive: [],
        aboutMe: "",
    })
}